import React from 'react';
import { ServiceVariationWrapper } from '../../components/Themed.js';
import ServicesVariationItem from './ServicesVariationItem.js';

class ServicesVariation extends React.Component {
  constructor(props) {
    super(props);

    this.isSelected = this.isSelected.bind(this);
    this.selectClick = this.selectClick.bind(this);
  }

  selectClick(id, idParent, selected) {
    this.props.onSelect(id, idParent, selected);
  }

  isSelected(variationId, parentVariationId) {
    const { clientVariations } = this.props;
    const isSelected =
      clientVariations.filter(
        cv =>
          cv.variationId === variationId &&
          cv.parentVariationId === parentVariationId
      ).length > 0;

    return isSelected;
  }

  render() {
    const { variation, currencySymbol, showLoader, selectedChildId } = this.props;
    const isSelected = this.isSelected(variation.id);
    if (!this.props.prices) return null;

    const servicePrice = this.props.prices.filter(
      p => p.variationId === variation.id
    )[0];

    if (servicePrice == null || servicePrice.minPrice == null) return null;

    return (
      <React.Fragment>
        <ServiceVariationWrapper className="relative" selected={isSelected}>
          <ServicesVariationItem
            variation={variation}
            selected={isSelected}
            onSelect={this.selectClick}
            price={servicePrice}
            currencySymbol={currencySymbol}
            selectedChildId={selectedChildId}
          />
          {isSelected &&
            variation.addons.filter(addon => !addon.hidden).map(addon => (
              <ServicesVariationItem
                key={addon.id}
                addon={true}
                variation={addon}
                parentVariationId={variation.id}
                selected={this.isSelected(addon.id, variation.id)}
                onSelect={this.selectClick}
                currencySymbol={currencySymbol}
                price={
                  this.props.prices.filter(p => p.variationId === addon.id)[0]
                }
                selectedChildId={selectedChildId}
              />
            ))}
          {
            showLoader && (
              <div className="spinner-container-background">
                <div className="spinner-container">
                  <i className="fas fa-spinner fa-pulse services-spinner" />
                </div>
              </div>
            )
          }
        </ServiceVariationWrapper>
      </React.Fragment>
    );
  }
}

export default ServicesVariation;
